module.exports = __webpack_public_path__ + "img/pierre.e403698e.jpeg";